import { Column, Entity, JoinColumn, ManyToOne, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { OutreachAutomationStepExecutionEntity } from './outreach-automation-step-execution.entity';
import { OutreachCampaignEntity } from './outreach-campaign.entity';
import { OutreachInteractionEntity } from './outreach-interaction.entity';
import { OutreachTemplateEntity } from './outreach-template.entity';

@Entity('_outreach_send')
export class OutreachSendEntity extends BaseEntity {
	@Column('enum', {
		name: '_send_type',
		enum: ['campaign', 'automation', 'transactional'],
	})
	public sendType!: 'campaign' | 'automation' | 'transactional';

	@Column('enum', { name: '_campaign_type', enum: ['email', 'phone'] })
	public campaignType!: 'email' | 'phone';

	@Column('int', { name: '_fk__client__id', unsigned: true })
	public fkClientId!: number;

	@Column('varchar', { name: '_to_email', nullable: true, length: 255 })
	public toEmail!: string | null;

	@Column('varchar', { name: '_to_phone', nullable: true, length: 20 })
	public toPhone!: string | null;

	@Column('varchar', { name: '_to_name', nullable: true, length: 255 })
	public toName!: string | null;

	@Column('varchar', { name: '_from_email', nullable: true, length: 255 })
	public fromEmail!: string | null;

	@Column('varchar', { name: '_from_phone', nullable: true, length: 20 })
	public fromPhone!: string | null;

	@Column('varchar', { name: '_from_name', nullable: true, length: 255 })
	public fromName!: string | null;

	@Column('varchar', { name: '_subject', nullable: true, length: 255 })
	public subject!: string | null;

	@Column('longtext', { name: '_html_content', nullable: true })
	public htmlContent!: string | null;

	@Column('text', { name: '_text_content', nullable: true })
	public textContent!: string | null;

	@Column('text', { name: '_phone_script', nullable: true })
	public phoneScript!: string | null;

	@Column('json', { name: '_personalization_data', nullable: true })
	public personalizationData!: object | null;

	@Column('enum', {
		name: '_send_status',
		enum: ['pending', 'claimed', 'sending', 'sent', 'failed', 'bounced'],
	})
	public sendStatus!:
		| 'pending'
		| 'claimed'
		| 'sending'
		| 'sent'
		| 'failed'
		| 'bounced';

	@Column('timestamp', { name: '_scheduled_send_date' })
	public scheduledSendDate!: Date;

	@Column('varchar', { name: '_claimed_by', nullable: true, length: 100 })
	public claimedBy!: string | null;

	@Column('timestamp', { name: '_claimed_at', nullable: true })
	public claimedAt!: Date | null;

	@Column('timestamp', { name: '_sent_at', nullable: true })
	public sentAt!: Date | null;

	@Column('varchar', { name: '_ses_message_id', nullable: true, length: 255 })
	public sesMessageId!: string | null;

	@Column('varchar', { name: '_call_session_id', nullable: true, length: 255 })
	public callSessionId!: string | null;

	@Column('text', { name: '_error_message', nullable: true })
	public errorMessage!: string | null;

	@OneToMany(
		() => OutreachInteractionEntity,
		(outreachInteraction) => outreachInteraction.fkOutreachSend,
		{},
	)
	public outreachInteractions!: Array<OutreachInteractionEntity>;

	@ManyToOne(
		() => OutreachCampaignEntity,
		(outreachCampaign) => outreachCampaign.outreachSends,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{ name: '_fk__outreach_campaign__id', referencedColumnName: 'id' },
	])
	public fkOutreachCampaign!: OutreachCampaignEntity;

	@ManyToOne(
		() => OutreachTemplateEntity,
		(outreachTemplate) => outreachTemplate.outreachSends,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{ name: '_fk__outreach_template__id', referencedColumnName: 'id' },
	])
	public fkOutreachTemplate!: OutreachTemplateEntity;

	@ManyToOne(
		() => OutreachAutomationStepExecutionEntity,
		(outreachAutomationStepExecution) =>
			outreachAutomationStepExecution.outreachSends,
		{ onDelete: 'NO ACTION', onUpdate: 'NO ACTION' },
	)
	@JoinColumn([
		{
			name: '_fk__outreach_automation_step_execution__id',
			referencedColumnName: 'id',
		},
	])
	public fkOutreachAutomationStepExecution!: OutreachAutomationStepExecutionEntity;
}
